import { useState } from "react";
import type { CommentItem } from "@/types/content";

export default function CommentList({
  items,
  total,
}: {
  items: CommentItem[];
  total: number;
}) {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  return (
    <section id="comments" aria-labelledby="comments-title" className="mt-12">
      <div className="flex items-center justify-between">
        <h2
          id="comments-title"
          className="font-heading text-xl font-black text-foreground-950 md:text-2xl"
        >
          讨论区评论
        </h2>
        <span className="text-xs text-foreground-500 md:text-sm">共 {total} 条</span>
      </div>

      <ul className="mt-5 flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {items.map((comment) => {
          const isLiked = !!liked[comment.id];
          return (
            <li key={comment.id} className="flex gap-3.5 p-4 md:gap-4 md:p-5">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                <i className="ri-user-3-line"></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <span className="font-heading text-sm font-bold text-foreground-950">
                    {comment.author}
                  </span>
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    {comment.school}
                  </span>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {comment.content}
                </p>
                <button
                  type="button"
                  onClick={() => setLiked((prev) => ({ ...prev, [comment.id]: !prev[comment.id] }))}
                  aria-pressed={isLiked}
                  className={`mt-2.5 flex cursor-pointer items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs transition-colors whitespace-nowrap ${
                    isLiked
                      ? "border-primary-300 bg-primary-100 text-primary-700"
                      : "border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className={isLiked ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                  </span>
                  {comment.likes + (isLiked ? 1 : 0)}
                </button>
              </div>
            </li>
          );
        })}
      </ul>

      <p className="mt-4 text-xs leading-relaxed text-foreground-500">
        评论内容来自社区用户分享，请理性讨论。如需举报不实信息，可通过页面底部的联系方式反馈。
      </p>
    </section>
  );
}